import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Choice } from 'src/app/shared/components/select/choice.model';
import { BasicService } from 'src/app/shared/services/basic.service';
import * as URI from 'urijs';

@Component({
  selector: 'app-transformation-edition',
  templateUrl: './transformation-edition.component.html',
  styleUrls: ['./transformation-edition.component.scss'],
})
export class TransformationEditionComponent implements OnInit {
  // eslint-disable-next-line no-useless-escape
  hostnameRegex = /^[a-z\d]([a-z\d\-]*[a-z\d])?(\.[a-z\d]([a-z\d\-]*[a-z\d])?)*$/i;
  valueListWithTags = [];

  actionTypesChoices: Choice[] = [
    { id: 'add-argument', label: this.basicService.translate('account/links/transformations/actions/add-argument') },
    { id: 'set-argument', label: this.basicService.translate('account/links/transformations/actions/set-argument') },
    {
      id: 'set-argument-variable',
      label: this.basicService.translate('account/links/transformations/actions/set-argument-variable'),
    },
    { id: 'set-fragment', label: this.basicService.translate('account/links/transformations/actions/set-fragment') },
    { id: 'wrap-url', label: this.basicService.translate('account/links/transformations/actions/wrap-url') },
  ];

  private valueListWithoutTags = [
    'account_name',
    'aissistant_used',
    'conversation_start_time',
    'date',
    'message_discussion_id',
    'message_url',
    'pseudo',
    'satisfaction_survey_sent_date',
    'task_id',
    'task_url',
    'username',
    'survey_sent_mode',
  ];

  constructor(
    private basicService: BasicService,
    @Inject(MAT_DIALOG_DATA) public data: { transformation: any; tagLabelPerTaskTagId: any; is_encrypted: boolean }
  ) {}

  ngOnInit() {
    this.valueListWithTags = this.valueListWithoutTags.map(value => ({ id: value, label: value }));
    if (this.data.tagLabelPerTaskTagId) {
      this.valueListWithTags = this.valueListWithTags.concat(this.data.tagLabelPerTaskTagId);
    }
    this.sortValuesById();
    this.updateTransformationExample();
  }

  addAction() {
    this.data.transformation.actions.push({
      type: 'set-argument',
      name: 'argument',
      value: 'value',
    });
  }

  deleteAction(index) {
    this.data.transformation.actions.splice(index, 1);
  }

  updateTransformationExample() {
    const hostname = this.data.transformation.hostname
      ? this.data.transformation.hostname
      : this.basicService.translate('account/links/transformations/example-hostname');
    this.data.transformation.example = `http://${hostname}/to/url?name=value#fragment`;
  }

  updateActionOnTypeChange(action) {
    switch (action.type) {
      case 'add-argument':
        action.name = 'argument';
        action.value = 'value';
        break;
      case 'set-argument':
        action.name = 'argument';
        action.value = 'value';
        break;
      case 'set-argument-variable':
        action.name = 'argument';
        break;
      case 'set-fragment':
        action.value = 'fragment';
        break;
      case 'wrap-url':
        action.url = 'http://wrapper.com/';
        action.name = 'argument';
        break;
    }
  }

  actionResultExample(target_action) {
    if (!this.data.transformation.example) {
      return '';
    }
    let example = URI(this.data.transformation.example);
    if (this.data.transformation.hostname && example.hostname() !== this.data.transformation.hostname) {
      return example.toString();
    }
    for (let i = 0; i < this.data.transformation.actions.length; i++) {
      const action = this.data.transformation.actions[i];
      if (action.type === 'add-argument') {
        example = example.addSearch(action.name, action.value);
      } else if (action.type === 'set-argument') {
        example = example.setSearch(action.name, action.value);
      } else if (action.type === 'set-argument-variable') {
        example = example.setSearch(action.name, action.value);
      } else if (action.type === 'set-fragment') {
        example = example.fragment(action.value);
      } else if (action.type === 'wrap-url') {
        const url = URI(action.url || '');
        url.setSearch(action.name, example.toString());
        example = url;
      }
      if (action === target_action) {
        break;
      }
    }
    return example.toString();
  }

  private sortValuesById() {
    this.valueListWithTags = this.valueListWithTags.sort((v1, v2) => {
      if (v1.id < v2.id) {
        return -1;
      }
      if (v1.id > v2.id) {
        return 1;
      }
      return 0;
    });
  }
}
